import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AssignSurvey from "../../../components/common/survey/AssignSurvey";
import { useLocation } from "react-router-dom";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";

function SurveyAssignPage() {
  const { userType } = useAuthStore();
  const location = useLocation();
  const surveyID = location.state || {};

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <AssignSurvey surveyID={surveyID} />
    </AdminLayout>
  );
}

export default SurveyAssignPage;
